<template>
  <div v-if="loading" class="loader menu dinline-block vtop fs14 pl35" >
    <div class="loader-inner ball-pulse">
      <div></div>
      <div></div>
      <div></div>
    </div>
  </div>
  <div v-else class="menu dinline-block vtop fs14">
    <div class="cont tleft pt50 pl35">
      <div class="fs24 tcenter pl20 pr20">{{info.title}}</div>
      <div class="tc-red fs16 tcenter mt20">
        <span class="mr35">浏览：{{info.view_count}}</span>
        <span>发布时间：{{info.created_at}}</span>
      </div>
      <div class="ncont tc6 fs16 lh20" style="padding: 60px 35px">
        <a v-for="(file,index) in info.article_file" :href="file" style="display: block;" class="hred" :download="file|getFileName">{{file|getFileName}}</a>
      </div>
      <div class="alink ml30 mr30 pl20 pt30">
        <div class="fs16 mb10" v-if="info.pre_article">
          <span>上一篇：</span>
          <router-link :to="{path:'/evn/detail',query:{article_id:info.pre_article.id,num:parseInt($route.query.num)-1,pid:$route.query.pid,id:$route.query.id}}" class="hred">{{info.pre_article.title}}</router-link>
        </div>
        <div class="fs16 mb10" v-if="info.next_article">
          <span>下一篇：</span>
          <router-link :to="{path:'/evn/detail',query:{article_id:info.next_article.id,num:parseInt($route.query.num)+1,pid:$route.query.pid,id:$route.query.id}}" class="hred">{{info.next_article.title}}</router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Detail",
  data(){
    return {
      info:{},
      msg:'',
      loading:false
    }
  },
  filters:{
    getFileName(fileName){
      var start = fileName.lastIndexOf('/')
      return fileName.substr(start+1);
    }
  },
  created() {
  },
  watch:{
    $route:{
      deep:true,
      immediate:true,
      handler:function (n,o) {
        this.updateData();
      }
    }
  },
  methods:{
    backTop() {
      document.body.scrollTop = 0
      document.documentElement.scrollTop = 0
    },
    updateData(){
      this.id = this.$route.query.id
      this.pid = this.$route.query.pid
      this.backTop();
      this.getData();
    },
    getData(){
      this.loading = true
      var getParam = {}
      getParam['id'] = this.$route.query.article_id
      getParam['num'] = this.$route.query.num
      this.$request.get('article/detail',getParam,response => {
        if(response.status == 200){
          if(response.data.code != 200){
            this.msg = response.data.message;
          }else{
            let res = response.data.data
            this.info = res
          }
          console.log(this.info)
        }else{
          this.msg = '请求失败';
        }
        this.loading = false
      },error => {
        console.log(error)
      })
    },
  },
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/evn/Dfile.vue